/**
 * Normalizes a URL by ensuring it has a proper HTTPS protocol prefix.
 *
 * @param url - The URL to normalize
 * @returns The normalized URL with HTTPS protocol, or empty string if input is invalid
 *
 * Rules:
 * - If URL already has https://, return as-is
 * - If URL has http://, convert to https://
 * - If URL has no protocol, add https://
 * - If URL is empty/null/undefined, return empty string
 */
export const normalizeWebsiteUrl = (url: string | null | undefined): string => {
  if (!url || typeof url !== "string" || url.trim().length === 0) {
    return "";
  }

  const trimmedUrl = url.trim();

  // Already has https protocol
  if (trimmedUrl.toLowerCase().startsWith("https://")) {
    return trimmedUrl;
  }

  // Has http protocol - convert to https
  if (trimmedUrl.toLowerCase().startsWith("http://")) {
    return trimmedUrl.replace(/^http:\/\//i, "https://");
  }

  // No protocol - add https
  return `https://${trimmedUrl}`;
};
